var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContenedorCampos',{attrs:{"titulo":'',"isObligatorio":'false',"error":_vm.error}},[_c('v-checkbox',{attrs:{"disabled":_vm.bDeshabilitado,"label":_vm.titulo,"hide-details":""},model:{value:(_vm.selectValue),callback:function ($$v) {_vm.selectValue=$$v},expression:"selectValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }